import Procedure from "../procedure/Procedure";

const ProcedureBanner = ({ title, description, steps }) => {
  return (
    <section className="py-16 lg:py-28 container flex flex-col justify-center items-center text-center">
      <h2 aria-level={2}>{title}</h2>
      <p className="mt-4 max-w-[40rem]">{description}</p>
      <Procedure steps={steps} />
    </section>
  );
};
export default ProcedureBanner;
